import { z } from 'zod';

export const EventTypeCodeEnum = z.enum(['ACTION_PATH', 'NEW_RISK', 'OTHER', 'REMEDIATION', 'RULES_CHANGE']);
export const EventTrackerStatusEnum = z.enum(['ACTIVE', 'INACTIVE']);

export const EventSchema = z.object({
  actualRecordCount: z.number().int(),
  associatedActionPathId: z.string().nullable().optional(),
  createdBy: z.email(),
  createdDate: z.string().refine(
    (val) => {
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{1,3}$/.test(val);
    },
    {
      message: 'Invalid ISO date format (expected YYYY-MM-DDTHH:mm:ss.SSS)',
    }
  ),
  endDate: z
    .string()
    .nullable()
    .refine(
      (val) => {
        return val === null || /^\d{4}-\d{2}-\d{2}$/.test(val);
      },
      {
        message: 'Invalid ISO date format (expected YYYY-MM-DD) or null',
      }
    ),
  eventId: z.string().nullable(),
  eventTrackerStatus: EventTrackerStatusEnum,
  eventTypeCode: EventTypeCodeEnum,
  expectedRecordCount: z.number().int(),
  impactedSystems: z.array(z.string()),
  lastModifiedBy: z.email(),
  lastModifiedDate: z.string().refine(
    (val) => {
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{1,3}$/.test(val);
    },
    {
      message: 'Invalid ISO date format (expected YYYY-MM-DDTHH:mm:ss.SSS)',
    }
  ),
  notes: z.string(),
  startDate: z.string().refine(
    (val) => {
      return /^\d{4}-\d{2}-\d{2}$/.test(val);
    },
    {
      message: 'Invalid ISO date format (expected YYYY-MM-DD)',
    }
  ),
  title: z.string(),
});
